module.exports = __webpack_public_path__ + "09565c7545e2618d43553ac053a814a6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/harp.png
// module id = 1902
// module chunks = 0